import styled, { css } from 'styled-components';
import {
  CONFIRM_DIALOG_TONE_CAUTION,
  CONFIRM_DIALOG_TONE_DANGER,
  CONFIRM_DIALOG_TONE_INFO,
  type ConfirmDialogTone,
} from './ConfirmDialog.constants';

const TONE_FG: Record<
  ConfirmDialogTone,
  (theme: { colors?: Record<string, string | undefined> }) => string
> = {
  [CONFIRM_DIALOG_TONE_DANGER]: ({ colors = {} }) =>
    colors.error ?? '#FFB4AB',
  [CONFIRM_DIALOG_TONE_CAUTION]: ({ colors = {} }) =>
    colors.caution ?? '#FFDF9E',
  [CONFIRM_DIALOG_TONE_INFO]: ({ colors = {} }) =>
    colors.primary ?? '#C1C1FF',
};

/**
 * The 36×36 tinted icon disc rendered in the dialog header. Keeps the
 * tone visible even when the consumer overrides the icon glyph itself.
 */
export const HeaderIconDisc = styled.span<{ $tone: ConfirmDialogTone }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  flex-shrink: 0;

  ${({ $tone, theme }) => {
    const fg = TONE_FG[$tone](theme);
    return css`
      background: color-mix(in oklch, ${fg} 18%, transparent);
      color: ${fg};
    `;
  }}

  & > svg,
  & > .material-symbols-rounded {
    width: 20px;
    height: 20px;
    font-size: 20px;
  }
`;

export const Description = styled.p`
  margin: 0;
  ${({ theme: { colors = {} } }) => css`
    color: ${colors.onSurfaceVariant ?? '#C7C4D7'};
  `}
  font-size: 13.5px;
  line-height: 1.5;
`;

export const FooterRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  width: 100%;
`;
